module.exports = __webpack_public_path__ + "static/media/galdisa_blogImg16.0f0a6d3a.jpg";